module.exports = __webpack_public_path__ + "img/login6.76145a17.jpg";